module.exports = __webpack_public_path__ + "img/奖章3级@3x.d2fc448a.png";